import { Observable } from "rxjs";
export interface AWRCObserverModel {
    awrcObservable: Observable<AWRCData>
};
export interface AWRCRareStreamData {
    [x: string]: string
};
export interface GroupedStreamData {
    waterRatioHistory: string,
    waterRatioSp: string,
    ovSP: string,
    ovAvg: string,
    lastBatch: string
};
export interface AWRCParsedStreamData {
    BU: GroupedStreamData,
    BR: GroupedStreamData,
    LastBatchPressed: boolean,
    FtdInletOvAverage: string,
    FtdInletOvSp: string
};

export enum AWRCParameters {
    BU = 'BU',
    BR = 'BR',
    // Temporarily removed
    // FC = 'FC',
    // OR = 'OR',
};

export type AWRCData = Partial<AWRCParsedStreamData>;

export interface IBlendHistorianParam { field: string, value: string };